import _ from 'lodash';
import { DateTime } from 'luxon';
import { FieldType, TemplateField } from '../types/FieldCommon';
import { humanizeDate, humanizeTimestamp } from './dateUtils';

export const handleSplitInput = <T>(input: string, currentValues: T[], onUpdate: (newValues: T[]) => void, itemBuilder: (name: string, index: number) => T) => {
  const items = input
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item.length > 0)
    .map(itemBuilder);

  const newValues = [...currentValues, ...items];
  onUpdate(newValues);
};

export const formatFieldValue = (field: Pick<TemplateField, 'type' | 'value'>): string => {
  const { type, value } = field;

  if (_.isNil(value) || value === '') return '—';

  switch (type) {
    case FieldType.DATETIME:
      return humanizeTimestamp(String(value));
    case FieldType.DATE:
      return humanizeDate(String(value));
    case FieldType.TIME:
      return DateTime.fromISO(String(value)).toLocaleString(DateTime.TIME_SIMPLE);
    case FieldType.CHECKBOX:
      return value ? 'Yes' : 'No';
    case FieldType.MULTISELECT:
      return Array.isArray(value) && value.length ? value.join(', ') : '—';
    default:
      return String(value);
  }
};

export const isSelectionType = (type: FieldType): boolean => _.includes([FieldType.AUTOCOMPLETE, FieldType.MULTISELECT], type);
